import { render, staticRenderFns } from "./AddFence.vue?vue&type=template&id=3519eae4&scoped=true&"
import script from "./AddFence.vue?vue&type=script&lang=js&"
export * from "./AddFence.vue?vue&type=script&lang=js&"
import style0 from "./AddFence.vue?vue&type=style&index=0&id=3519eae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3519eae4",
  null
  
)

export default component.exports